import { useEffect, useState } from "react";
import router from "next/router";
import NotFound from "./404.js";

const Default = () => {
  const [isPage404, setIsPage404] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !isPage404) {
      let fullPathname = window.location.pathname + window.location.search;
      if (fullPathname.includes("_default")) fullPathname = "/dashboard";
      router.push(fullPathname).catch((err) => {
        setIsPage404(true);
      });
    }
  });

  if (isPage404) return <NotFound />;

  return null;
};

Default.isUnprotected = true;

export default Default;
